import {GAME_INFO as GI} from './common/game'

export default class Cards extends PIXI.Container
{
    constructor(configGame, delegateGetCard, delegateGetDataReady)
    {
        super();

        let self = this;

        const packFolder = configGame.packFolder;
        this.packFolder = packFolder;
        const config = configGame.Cards;

        this.GCountSuit = 4;
        this.GCountNominal = 9;

        this.GCountShirts = 12;
        this.GCardsScale = {x: 1.0, y: 1.0};

        this.GCardSizeX = config.GCardSizeX;
        this.GCardSizeY = config.GCardSizeY;

        this.GCardAnchorX = 0.5;
        this.GCardAnchorY = 0.5;

        this.GShirtsOffsetX = config.GShirtsOffsetX;
        this.GNewRoundEnd = {x: config.GNewRoundEnd.pos.x + this.GCardSizeX * this.GCardAnchorX, y: config.GNewRoundEnd.pos.y + this.GCardSizeY * this.GCardAnchorY};
        this.GNewRoundLast = {x: this.GNewRoundEnd.x + this.GShirtsOffsetX * (this.GCountShirts - 1), y: this.GNewRoundEnd.y - this.GShirtsOffsetX * (this.GCountShirts - 1)};
        this.GNewRoundStart = {x: this.GNewRoundEnd.x, y: this.GNewRoundEnd.y - 200};
        this.GTimeMoveOnStart = 500;

        this.GCardOffsetX = config.GCardOffsetX;
        this.GCardSlide   = config.GCardSlide;
        this.GDealerStart = {x: config.GDealerStart.pos.x + this.GCardSizeX * this.GCardAnchorX, y: config.GDealerStart.pos.y + this.GCardSizeY * this.GCardAnchorY};
        this.GPlayerStart = {x: config.GPlayerStart.pos.x + this.GCardSizeX * this.GCardAnchorX, y: config.GPlayerStart.pos.y + this.GCardSizeY * this.GCardAnchorY};
        this.GDelayThrowCard = 500;
        this.GTimeMove = 500;
        this.GTimeRotate = 150;

        this.GShadowOffset = 15;
        this.GScaleFake3D = 0.3;



        this.delegateGetCard = delegateGetCard;
        this.delegateGetDataReady = delegateGetDataReady;

        this.sndDownDeck = sounds.get("res/sounds/down_deck");
        this.sndSlideDeck = sounds.get("res/sounds/slide_deck");
        this.sndFlyCard = sounds.get("res/sounds/fly_card");

        this.sndArrRotateCard = [];
        for (let i = 0; i < 3; ++i) {
            this.sndArrRotateCard.push(sounds.get("res/sounds/rotate" + i));
        }

        // overlap shirts without separate Container removeChild/addChild
        this.layerCards = new PIXI.Container();
        this.addChild(this.layerCards);

        this.arrCardsTextures0 = [];
        this.arrCardsTextures1 = [];
        this.arrCards = [];
        for (let suit = 0; suit < this.GCountSuit; ++suit) {

            for (let nominal = 0; nominal < this.GCountNominal; ++nominal) {

                let cardStruct = this.createCard(suit, nominal);
                cardStruct.card.scale.set(this.GCardsScale.x, this.GCardsScale.y);
                cardStruct.card.anchor.x = this.GCardAnchorX;
                cardStruct.card.anchor.y = this.GCardAnchorY;
                cardStruct.card.visible = false;

                this.layerCards.addChild(cardStruct.card);
                this.arrCards.push(cardStruct.card);

                this.arrCardsTextures0.push(cardStruct.tex0);
                this.arrCardsTextures1.push(cardStruct.tex1);
            }
        }

        for (let i = 0; i < this.GCountSuit * this.GCountNominal; ++i) {
            let shadow = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "shadow.png"]);
            shadow.anchor.x = this.GCardAnchorX;
            shadow.anchor.y = this.GCardAnchorY;
            this.arrCards[i].addChild(shadow);
        }

        this.arrTextureShirts = [PIXI.utils.TextureCache[packFolder + "shirt_0.png"], PIXI.utils.TextureCache[packFolder + "shirt_1.png"]];

        let getShirts = function(count, isWithShadow)
        {
            let arr = [];
            for (let i = 0; i < count; ++i) {
                let parent = isWithShadow ? new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "shadow_full.png"]) : new PIXI.Sprite(self.arrTextureShirts[0]);
                parent.scale.set(self.GCardsScale.x, self.GCardsScale.y);
                parent.anchor.x = self.GCardAnchorX;
                parent.anchor.y = self.GCardAnchorY;
                parent.visible = false;
                self.addChild(parent);
                arr.push(parent);

                if (isWithShadow) {
                    let child = new PIXI.Sprite(self.arrTextureShirts[0]);
                    child.anchor.x = self.GCardAnchorX;
                    child.anchor.y = self.GCardAnchorY;
                    parent.addChild(child);
                }
            }
            return arr;
        };

        this.arrStaticShirts = getShirts(this.GCountShirts, false);
        this.arrMoveShirts = getShirts(this.GCountShirts, true);

        this.queueResult = [];

        // 36 карт (сокращённая колода, от шестёрок до тузов);
        // for (let suit = 0; suit < this.GCountSuit; ++suit)
        // {
        //     for (let nominal = 0; nominal < this.GCountNominal; ++nominal)
        //     {
        //         let card = this.arrCards[suit * this.GCountNominal + nominal];
        //         card.visible = true;
        //         card.position.set(200 + nominal * 50, 100 + suit * 100);
        //     }
        // }
    };

    clearStates () {
        for (let obj of this.arrCards) obj.visible = false;

        this.sndFlyCard.stop();
        this.sndDownDeck.stop();
        this.sndSlideDeck.stop();

        for (let obj of this.arrStaticShirts) if (obj.moveTween) obj.moveTween.stop();
        for (let obj of this.arrMoveShirts) if (obj.scaleTween) obj.scaleTween.stop();
        for (let obj of this.arrMoveShirts) if (obj.moveTween) obj.moveTween.stop();
        for (let obj of this.arrMoveShirts) if (obj.timeoutID) clearTimeout(obj.timeoutID);
        for (let obj of this.arrMoveShirts) obj.visible = false;

        this.queueResult = [];
    }

    placeDeck() {
        let i = 0;
        for (let obj of this.arrStaticShirts) {
            obj.visible = true;
            obj.alpha = 1;
            obj.rotation = 0;
            obj.position.set(this.GNewRoundEnd.x + this.GShirtsOffsetX * i, this.GNewRoundEnd.y - this.GShirtsOffsetX * i);
            i++;
        }
    }

    terminate ()
    {
        this.removeChildren();
        this.destroy();

        this.clearStates();

        this.layerCards = null;

        for (let obj of this.arrCards) obj = null;
        this.arrCards = null;

        for (let obj of this.arrCardsTextures0) obj = null;
        this.arrCardsTextures0 = null;

        for (let obj of this.arrCardsTextures1) obj = null;
        this.arrCardsTextures1 = null;

        for (let obj of this.arrStaticShirts) obj = null;
        this.arrStaticShirts = null;

        for (let obj of this.arrMoveShirts) obj = null;
        this.arrMoveShirts = null;


        this.sndDownDeck.stop();
        this.sndDownDeck = null;
        this.sndSlideDeck.stop();
        this.sndSlideDeck = null;
        this.sndFlyCard.stop();
        this.sndFlyCard = null;
        for (let sound of this.sndArrRotateCard) { sound.stop(); sound = null; }
    }

    prepareNewRound (done, isFirstRun = true)
    {
        let self = this;

        let lastInd = this.arrStaticShirts.length - 1;
        let ind = 0;

        for (let obj of this.arrCards) {
            obj.visible = false;
        }

        if (!isFirstRun) {
            for (let obj of self.arrStaticShirts) {
                obj.position = {
                    x: self.GNewRoundEnd.x + self.GShirtsOffsetX * ind,
                    y: self.GNewRoundEnd.y - self.GShirtsOffsetX * ind
                };
                obj.rotation = 0;
                obj.visible = true;
                obj.alpha = 1;

                if (ind === lastInd)
                    done();
                ind++;
            }

            return;
        }



        let moveShakeCards;

        this.sndDownDeck.play();

        ind = 0;
        for (let obj of this.arrStaticShirts) {
            (function (indCopy) {
                obj.position.set(self.GNewRoundStart.x, self.GNewRoundStart.y);
                obj.rotation = -Math.PI;
                obj.visible = true;
                obj.alpha = 0;

                obj.moveTween = new TWEEN.Tween(obj.position)
                    .to({y: self.GNewRoundEnd.y}, self.GTimeMoveOnStart)
                    .onUpdate(function (delta) {
                        if (obj.alpha < 1) {
                            obj.alpha = Math.min(1, 1 * delta);
                        }
                    }.bind(obj))
                    .onComplete(function () {
                        obj.alpha = 1;
                        if (indCopy === lastInd)
                            moveShakeCards(done);
                    })
                    .start();
            })(ind);
            ind++;
        }

        let moveSideCards;

        moveShakeCards = function (done) {
            let ind = 0;
            for (let obj of self.arrStaticShirts) {
                (function (indCopy) {
                    obj.moveTween = new TWEEN.Tween(obj)
                        .to({rotation: 0}, 500)
                        .delay(indCopy * 60)
                        .onComplete(function () {
                            if (indCopy === lastInd)
                                moveSideCards(done);
                        })
                        .start();
                })(ind);
                ind++;
            }
        };

        moveSideCards = function (done) {
            self.sndSlideDeck.play();
            let ind = 0;
            for (let obj of self.arrStaticShirts) {
                (function (indCopy) {
                    obj.moveTween = new TWEEN.Tween(obj.position)
                        .to({x: self.GNewRoundEnd.x + self.GShirtsOffsetX * indCopy, y: self.GNewRoundEnd.y - self.GShirtsOffsetX * indCopy}, 300)
                        .onComplete(function () {
                            if (indCopy === lastInd)
                                done();
                        })
                        .start();
                })(ind);
                ind++;
            }
        };
    }

    startNewRound (done)
    {
        let self = this;
        const count = GI.countCardsOnStartAll;
        let iD = 0, iP = 0;
        for (let i = 0; i < count; ++i) {
            (function (indCopy) {
                let isPlayer = indCopy % 2 === 0;
                self.moveNextCard(isPlayer, isPlayer ? iP++ : iD++, 200 + self.GDelayThrowCard * indCopy, function () {
                    if (indCopy === count - 1) {
                        done();
                    }
                });
            })(i);
        }
    }

    moveNextCard (isPlayer, ind, timeout, done)
    {
        if (this.arrMoveShirts.length === 0 || !this.delegateGetCard)
            return;

        let pos = isPlayer ? this.GPlayerStart : this.GDealerStart;
        pos = {x: pos.x + this.GCardOffsetX * ind, y: pos.y};

        // что бы поочереди брались карты, если после обрыва сети запрос отправляют множество карт
        let id = isPlayer ? 10 + ind: 20 + ind;
        this.queueResult.push(id);

        let self = this;

        let moveShirt;

        let obj = self.arrMoveShirts.pop();
        this.arrMoveShirts.unshift(obj);
        obj.timeoutID = setTimeout(function() {
            self.sndSlideDeck.play();
            obj.position.set(self.GNewRoundLast.x, self.GNewRoundLast.y);
            obj.scale.set(self.GCardsScale.x, self.GCardsScale.y);
            obj.visible = true;
            let time = 200;
            obj.moveTween = new TWEEN.Tween(obj.position)
                .to({x: obj.position.x + self.GCardSlide, y: obj.position.y - self.GCardSlide + self.GShadowOffset}, time)
                .onUpdate(function (delta) {
                    let scale = 1.0 + self.GScaleFake3D * delta;
                    obj.scale.set(scale, scale);
                }.bind(obj))
                .onComplete(function () {
                    moveShirt(obj, done);
                })
                .start();
            let child = obj.children[0];
            child.position.set(0, 0);
            child.moveTween = new TWEEN.Tween(child.position)
                .to({x: child.position.x + self.GShadowOffset, y: child.position.y - self.GShadowOffset}, time)
                .start();
        }, timeout);

        let someTest;

        moveShirt = function (obj, done) {
            self.sndFlyCard.play();
            self.removeChild(obj);
            self.addChild(obj);
            let child = obj.children[0];
            const startS = 1.0 + self.GScaleFake3D;
            const startX = child.position.x;
            const startY = child.position.y;
            const deltaStart = 0.7;
            const l = 1.0 - deltaStart;
            obj.moveTween = new TWEEN.Tween(obj.position)
                .to({x: pos.x, y: pos.y}, self.GTimeMove)
                .onUpdate(function (delta) {
                    if (delta > deltaStart) {
                        let percent = ((delta - deltaStart) / l);
                        let offset = self.GShadowOffset * percent;
                        obj.children[0].position.set(startX - offset, startY + offset);

                        let scale = startS - self.GScaleFake3D * percent;
                        obj.scale.set(scale, scale);
                    }
                }.bind(obj))
                .onComplete(function () {
                    someTest(obj, done);
                })
                .start();
        };

        let rotateShirt;

        someTest = function (obj, done) {
            // console.log(" isDataReady ", self.delegateGetDataReady());
            if (self.delegateGetDataReady() && self.queueResult[0] === id) {
                self.queueResult.shift();
                rotateShirt(obj, done);
            }
            else {
                obj.timeoutID = setTimeout(() => {someTest(obj, done)}, 500);
            }
        };

        let rotateCard;

        rotateShirt = function (obj, done) {
            self.sndArrRotateCard[Math.floor(Math.random() * self.sndArrRotateCard.length)].play();
            obj.scaleTween = new TWEEN.Tween(obj.scale)
                .to({x: 0.005}, self.GTimeRotate)
                .easing(TWEEN.Easing.Sinusoidal.Out)
                .onComplete(function() {
                    obj.visible = false;
                    rotateCard(done);
                })
                .start();
        };

        rotateCard = function (done) {
            let obj = self.arrCards[self.delegateGetCard(isPlayer, ind)];
            self.layerCards.removeChild(obj);
            self.layerCards.addChild(obj);

            obj.visible = true;
            obj.scale.x = 0.005;
            obj.position.set(pos.x, pos.y);

            obj.scaleTween = new TWEEN.Tween(obj.scale)
                .to({x: self.GCardsScale.x}, self.GTimeRotate)
                .easing(TWEEN.Easing.Sinusoidal.Out)
                .onComplete(function () {
                    done();
                })
                .start();
        };
    }

    placeNextCard (isPlayer, ind)
    {
        let pos = isPlayer ? this.GPlayerStart : this.GDealerStart;

        let obj = this.arrCards[this.delegateGetCard(isPlayer, ind)];
        this.layerCards.removeChild(obj);
        this.layerCards.addChild(obj);

        pos = {x: pos.x + this.GCardOffsetX * ind, y: pos.y};
        obj.position.set(pos.x, pos.y);
        obj.scale.x = 1;
        obj.visible = true;
    }

    setCardsSkin(ind)
    {
        for (let obj of this.arrStaticShirts) {
            obj.texture = this.arrTextureShirts[ind];
        }
        for (let obj of this.arrMoveShirts) {
            obj.children[0].texture = this.arrTextureShirts[ind];
        }
        let cardTextures = ind === 0 ? this.arrCardsTextures0 : this.arrCardsTextures1;
        for (let i = 0; i < this.GCountSuit * this.GCountNominal; ++i) {
            this.arrCards[i].texture = cardTextures[i];
        }
    }


    createCard(suite, nominal)
    {
        let suiteName = null;
        switch(suite) {
            case 0: suiteName = "hearts";    break;
            case 1: suiteName = "diamonds";  break;
            case 2: suiteName = "spades";    break;
            case 3: suiteName = "clubs";     break;
        }

        let texture0 = PIXI.utils.TextureCache[this.packFolder + suiteName + "_0_%d.png".$(nominal)];
        let texture1 = PIXI.utils.TextureCache[this.packFolder + suiteName + "_1_%d.png".$(nominal)];

        let card = new PIXI.Sprite(texture0);
        card.anchor.set(0.5, 0);

        return {card: card, tex0: texture0, tex1: texture1};
    }
}


// WEBPACK FOOTER //
// ./src/cards.es6